import { render, staticRenderFns } from "./LabResultReviewDialog.vue?vue&type=template&id=ab2273ce"
import script from "./LabResultReviewDialog.vue?vue&type=script&lang=js"
export * from "./LabResultReviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab2273ce')) {
      api.createRecord('ab2273ce', component.options)
    } else {
      api.reload('ab2273ce', component.options)
    }
    module.hot.accept("./LabResultReviewDialog.vue?vue&type=template&id=ab2273ce", function () {
      api.rerender('ab2273ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryLabResult/LabResultReviewDialog.vue"
export default component.exports